<template>
  <div class="page-company">
    <tabbed-view :tabs="getTabs()"/>
  </div>
</template>

<script>

import TabbedView from '@/views/components/tabs/TabbedView';
import PageTitle from "@/views/components/extra-components/layout/PageTitle";
import {mapGetters} from 'vuex';

export default {
  name: "Facility",
  components: {
    TabbedView,
    PageTitle,
  },
  computed: {
    ...mapGetters({
      isDeleted: 'getIsDeleted'
    })
  },
  methods: {
    getTabs() {
      return [
        {
          label: 'Details',
          route: 'company.view',
        },
        {
          label: 'Commercial Products',
          route: 'company.commercial-products.view',
        },
        {
          label: 'Addresses',
          route: 'company.addresses.list',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'TOBAs',
          route: 'company.tobas.list',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Contacts',
          route: 'company.contacts.list',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Distribution Lists',
          route: 'company.distribution-list.list',
          hideIfDeleted: this.isDeleted,
        },
      ]
    }
  },
}
</script>
